import { getFlpDisabledPropertyMessage } from 'automation-ui-core/utils/getFlpDisabledPropertyMessage';
export function flattenPropertyGroups(propertiesByGroup) {
  return propertiesByGroup.flatMap(({
    properties
  }) => properties);
}
export function findProperty(propertyName, propertiesByGroup) {
  let foundProperty;
  propertiesByGroup.some(({
    properties
  }) => properties.some(property => {
    if (property.name === propertyName) {
      foundProperty = property;
    }
    return foundProperty !== undefined;
  }));
  return foundProperty;
}
export function isVisible({
  hidden
}) {
  return !hidden;
}
export function supportsPlainTextMatching({
  type,
  fieldType
}) {
  return type === 'string' || type === 'bool' || type === 'enumeration' && ['radio', 'select', 'booleancheckbox'].includes(fieldType);
}
export function isRestricted({
  fieldLevelPermission
}) {
  const accessLevel = fieldLevelPermission === null || fieldLevelPermission === void 0 ? void 0 : fieldLevelPermission.accessLevel;
  return accessLevel !== 'not_specified' && accessLevel !== '';
}
export function convertProperyToOption(property) {
  const {
    label,
    name,
    description
  } = property;
  const flpOverrides = isRestricted(property) ? {
    disabled: true,
    icon: 'hide',
    tooltip: getFlpDisabledPropertyMessage(name)
  } : {};
  return Object.assign({
    text: label,
    value: name,
    help: description
  }, flpOverrides);
}

/**
 * See https://knowledge.hubspot.com/articles/kcs_article/workflows/why-am-i-unable-to-select-my-target-property-when-copying-properties-using-a-workflow
 */
export const arePropertyTypesCopyCompatible = ({
  type: destType
}, {
  type: sourceType
}) => {
  if (!destType || !sourceType || destType === sourceType) {
    return true;
  }

  // Note: there is no entry for STRING because these cannot
  // be copied into any other property type. Also omitted are
  // source types that match destination types.
  switch (sourceType) {
    case 'date':
      return destType === 'datetime';
    case 'datetime':
      return destType === 'date';
    case 'enumeration':
      {
        return ['string', 'bool'].includes(destType);
      }
    case 'number':
      return destType === 'string';
    case 'bool':
      return destType === 'enumeration';
    case 'phone_number':
      return destType === 'string';
    default:
      return false;
  }
};